import styles from './styles.module.scss';
import { TreeNodeData } from 'skill-tree/src/models';
import { useUpgradesStore } from '../../store/zustand/useUpgradesStore';
import { UpgradeType } from '../../types/game-types';
import { useGeneratorContext } from '../../store/generator-context';

export const NodeLink = ({ skill }: { skill: TreeNodeData }) => {
  const upgrades = useUpgradesStore((store) => store.upgrades);
  const entityType = useGeneratorContext();
  const upgrade = upgrades[entityType][skill.id as UpgradeType];

  return (
    <div
      className={`${styles.line} ${styles[upgrade.status || 'hidden']}`}
      style={{ backgroundImage: `url(ui/others/chain_link.png)` }}
    ></div>
  );
};
